import { useEffect, useState, useMemo } from 'react';
import { Card, Space, Table, Input, Button, Descriptions, Col, Row, Flex, Form, Select, Drawer, Modal } from 'antd';
import OrderService from "services/order"
import { formatCurrency } from "utils/number"
import { formatDate } from "utils/date"
import { useNavigate, useParams } from 'react-router';
import { useApp } from 'contexts/app';
import ProductVariantService from "services/product_variant"
import CustomerService from "services/customer"

import { PlusSquareOutlined, EditOutlined } from "@ant-design/icons"
import InputNumber from "components/input-number"
import { toSearchText } from "utils/text"

import { useWorkSpace } from "contexts/workspace"
import _ from "lodash"
import { useAddressPicker } from '.';


const service = new CustomerService();

const CustomerInfo = ({ id, open, onClose }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const { showLoading } = useApp();
    const { address, onChange, customer_id } = useAddressPicker();
    const [shippingAddresses, setShippingAddresses] = useState([]);
    const [selectedAddressIndex, setSelectedAddressIndex] = useState(undefined);

    const [form] = Form.useForm()

    useEffect(() => {
        form.setFieldsValue(address);
    }, [address])

    useEffect(() => {
        setIsModalOpen(open)
    }, [open])

    useEffect(() => {
        if (!open || !customer_id) {
            setShippingAddresses([]);
            setSelectedAddressIndex(undefined);
            return;
        }
        loadCustomerAddresses();
    }, [open, customer_id]);

    const normalizeShippingAddress = (list = [], customer = {}) => {
        let addresses = (list ?? []).map((x, index) => ({
            key: `${index}`,
            full_name: x?.full_name ?? customer?.full_name ?? "",
            phone_number: x?.phone_number ?? customer?.phone ?? "",
            address: x?.address ?? "",
            note: x?.note ?? "",
            is_default: !!x?.is_default,
        }));

        if (addresses.length === 0 && customer?.address) {
            addresses = [{
                key: "0",
                full_name: customer?.full_name ?? "",
                phone_number: customer?.phone ?? "",
                address: customer?.address ?? "",
                note: "",
                is_default: true,
            }];
        }

        if (addresses.length > 0 && !addresses.some(x => x.is_default)) {
            addresses[0].is_default = true;
        }

        return addresses;
    }

    const loadCustomerAddresses = async () => {
        const cus = await service.getByID(customer_id);
        if (!cus) {
            setShippingAddresses([]);
            setSelectedAddressIndex(undefined);
            return;
        }

        const addresses = normalizeShippingAddress(cus.shipping_address, cus);
        setShippingAddresses(addresses);

        const matched = addresses.findIndex(x => x.full_name == address?.full_name && x.phone_number == address?.phone_number && x.address == address?.address);
        if (matched >= 0) {
            setSelectedAddressIndex(`${matched}`);
            return;
        }

        const defaultAddress = addresses.find(x => x.is_default) ?? addresses[0];
        const defaultIndex = addresses.findIndex(x => x.key == defaultAddress?.key);
        if (defaultAddress) {
            setSelectedAddressIndex(`${defaultIndex}`);
        }
    }

    const onSelectExistingAddress = (value) => {
        setSelectedAddressIndex(value);
        const selected = shippingAddresses[Number(value)];
        if (!selected) {
            return;
        }
        form.setFieldsValue({
            phone_number: selected.phone_number,
            full_name: selected.full_name,
            address: selected.address,
        });
    }

    const showModal = () => {
        setIsModalOpen(true);
    };
    const handleOk = () => {
        setIsModalOpen(false);
    };
    const handleCancel = () => {
        setIsModalOpen(false);
    };
    const btnSaveClick = () => {
        form.submit();
    }
    const onFinish = async values => {

        onChange(values);
        onClose();

    };




    return (
        <>

            <Modal
                title="Sửa địa chỉ"
                closable={{ 'aria-label': 'Custom Close Button' }}
                open={open}
                onOk={handleOk}
                onCancel={onClose}
                footer={<Space>
                    <Button>Close</Button>
                    <Button onClick={btnSaveClick} type='primary'>Ok</Button>
                </Space>}
            >
                <Form layout='vertical' form={form}

                    onFinish={onFinish}

                >

                    {shippingAddresses.length > 0 && (
                        <Form.Item label="Địa chỉ có sẵn">
                            <Space direction='vertical' style={{ width: "100%" }}>
                                {shippingAddresses.map((x, index) => (
                                    <div key={x.key ?? index} style={{ border: "1px solid #f0f0f0", borderRadius: 8, padding: 8 }}>
                                        <Space style={{ width: "100%", justifyContent: "space-between" }} align='start'>
                                            <div>
                                                <div><b>{x.full_name}</b> - {x.phone_number}</div>
                                                <div>{x.address}</div>
                                                {x.is_default ? <div style={{ color: "#52c41a" }}>Mặc định</div> : null}
                                            </div>
                                            <Button
                                                type='link'
                                                onClick={() => onSelectExistingAddress(`${index}`)}
                                                disabled={selectedAddressIndex === `${index}`}
                                            >
                                                {selectedAddressIndex === `${index}` ? "Đã chọn" : "Chọn"}
                                            </Button>
                                        </Space>
                                    </div>
                                ))}
                            </Space>
                        </Form.Item>
                    )}




                    <Form.Item
                        label="Số điện thoại"
                        name={"phone_number"}
                        rules={[

                            {
                                required: true,
                                pattern: /^[0-9]{10}$/,
                                message: "Số điện thoại không đúng định dạng",

                            },


                        ]}
                    >
                        <Input />
                    </Form.Item>

                    <Form.Item
                        label="Họ  và tên"
                        name={"full_name"}

                    >
                        <Input />
                    </Form.Item>

                    <Form.Item
                        label="Địa chỉ"
                        name={"address"}

                    >
                        <Input />
                    </Form.Item>

                </Form>
            </Modal>
        </>
    );
};
export default CustomerInfo;